$(document).ready(function() {
    let currentStep = 1;
    let selectedInterest = '';
    
    // Regex patterns
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
    
    // Initialize - show only step 1
    $('.adrnl-form__paso').hide();
    $('.adrnl-form__paso--paso-1').show();
    
    // Step 1: Handle interest selection
    $('.adrnl-form__paso--paso-1 .button-adrnl').on('click', function() {
        selectedInterest = $(this).val();
        console.log('Selected interest:', selectedInterest);
        
        // Transition to step 2
        $('.adrnl-form__paso--paso-1').fadeOut(400, function() {
            $('.adrnl-form__paso--paso-2').fadeIn(400);
            currentStep = 2;
            updateStepper();
        });
    });
    
    // Step 2: Email validation and claim discount
    $('#emailCustomer').on('input', function() {
        validateEmail();
    });
    
    $('.adrnl-form__paso--paso-2 input[value="CLAIM DISCOUNT"]').on('click', function() {
        if (validateEmail()) {
            // Transition to step 3
            $('.adrnl-form__paso--paso-2').fadeOut(400, function() {
                $('.adrnl-form__paso--paso-3').fadeIn(400);
                currentStep = 3;
                updateStepper();
            });
        }
    });
    
    // Step 3: Phone validation and form submission
    $('#telephoneNumber').on('input', function() {
        validatePhone();
    });
    
    $('#submitBtn').on('click', function(e) {
        e.preventDefault(); // Prevent page refresh
        
        if (validatePhone()) {
            // Transition to step 4
            $('.adrnl-form__paso--paso-3').fadeOut(400, function() {
                $('.adrnl-form__paso--paso-4').fadeIn(400);
                currentStep = 4;
                updateStepper();
            });
            
            // Here you can add your form submission logic
            console.log('Form data:', {
                interest: selectedInterest,
                email: $('#emailCustomer').val(),
                phone: $('#telephoneNumber').val()
            });
        }
    });
    
    // Email validation function
    function validateEmail() {
        const email = $('#emailCustomer').val().trim();
        const claimButton = $('.adrnl-form__paso--paso-2 input[value="CLAIM DISCOUNT"]');
        
        if (email !== '' && emailRegex.test(email)) {
            claimButton.prop('disabled', false).removeClass('disabled');
            return true;
        } else {
            claimButton.prop('disabled', true).addClass('disabled');
            return false;
        }
    }
    
    // Phone validation function
    function validatePhone() {
        const phone = $('#telephoneNumber').val().trim();
        const submitButton = $('#submitBtn');
        
        if (phone !== '' && phoneRegex.test(phone)) {
            submitButton.prop('disabled', false).removeClass('disabled');
            return true;
        } else {
            submitButton.prop('disabled', true).addClass('disabled');
            return false;
        }
    }
    
    // Update stepper visual state
    function updateStepper() {
        $('.stepper-item').removeClass('stepper-item--active');
        $('.stepper-item').eq(currentStep - 1).addClass('stepper-item--active');
    }
    
    // Initialize disabled state for buttons
    $('.adrnl-form__paso--paso-2 input[value="CLAIM DISCOUNT"]').prop('disabled', true).addClass('disabled');
    $('#submitBtn').prop('disabled', true).addClass('disabled');

    //Copy Text function

    $('.copy-text').on('click', function () {
        const coupon = $('#coupon-code').text().trim();
  
        // temporary input
        const tempInput = $('<input>');
        $('body').append(tempInput);
        tempInput.val(coupon).select();
        document.execCommand('copy');
        tempInput.remove();
  
        // Mostrar el mensaje temporalmente
        const message = $('.copied-message');
        message.stop(true, true).fadeIn().delay(1500).fadeOut();
      });
});